import React from 'react'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import './mapa.css'

const redIcon = new L.DivIcon({
    html: `
    <svg width="24" height="36" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0C7.029 0 3 4.029 3 9c0 7.5 9 27 9 27s9-19.5 9-27c0-4.971-4.029-9-9-9z" fill="#E30613"/>
      <circle cx="12" cy="9" r="3" fill="white"/>
    </svg>`,
    className: '',
    iconSize: [24, 36],
    iconAnchor: [12, 36],
})

const Mapa = () => (
    <MapContainer
        center={[40.75, -73.95]}
        zoom={13}
        style={{
            width: '100%',
            height: '500px',
            borderRadius: '0px',
            border: 'none'
        }}
    >
        <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            className="grayscale-tiles"
        />
        <Marker position={[40.75, -73.95]} icon={redIcon} />
    </MapContainer>
)

export default Mapa
